module.exports = __webpack_public_path__ + "static/placeholdifier-53298fcd6983aa64e1e65876faf6e1e8.png";